module.exports = {
  QueryBalance: 'Tra cứu khách hàng trả trước',
  QueryDetail: 'Tra cứu chi tiết trả trước',
  BalanceDetail: 'Chi tiết biến động số dư',
  FinanceBalance: 'Số dư nghiệp vụ tài chính',
  SendBalance: 'Gửi danh sách',
  QuerySendBalanceState: 'Kiểm tra trạng thái gửi danh sách',
  InitializeBalance: 'Khởi tạo số dư',
  QuickSearchBalance: 'Tìm kiếm nhanh: Mã khách hàng',
  CustomerName: 'Tên khách hàng',
  CustomerCode: 'Mã khách hàng',
  SalesName: 'Bán hàng',
  ParentBranchName: 'Tên cơ quan cấp trên',
  ParentBranchCode: 'Mã cơ quan cấp trên',
  BranchName: 'Tên bộ phận quản lý',
  BranchCode: 'Mã bộ phận quản lý',
  BranchId: 'Cơ quan tiếp nhận',
  Balance: 'Số dư',
  DateCreated: 'Ngày tạo',
  State: 'Trạng thái đồng bộ danh sách',
  SubmittingAmount: 'Số tiền đang gửi',
  ShowChildData: 'Hiển thị công ty cấp dưới',
  ChangeAmount: 'Biến động số tiền',
  ChangeType: 'Loại biến động số dư',
  LatestBalance: 'Số dư mới nhất',
  ChangeDate: 'Ngày phát sinh',
  Currency: 'Loại tiền tệ',
  JobNo: 'Mã nghiệp vụ',
  FinanceUpdateDate: 'Ngày cập nhật nghiệp vụ tài chính',
  SyncDate: 'Ngày đồng bộ',
  CheckBalanceTitle: 'Số dư trả trước không đủ',
  CheckBalanceDetail: '{0}, [{1}]{2}: Số dư hiện tại RMB {3}. Nghiệp vụ đang gửi đã chiếm dụng RMB {4}. Lần gửi này RMB {5}',
  CheckBalanceDetail2: '[{0}]{1}: Số dư hiện tại RMB {2}. Nghiệp vụ đang gửi đã chiếm dụng RMB {3}. Lần gửi này RMB {4}',
  CustSettlement: 'Phương thức thanh toán khách hàng',
  InstCode: 'Mã điểm giao dịch',
  InstName: 'Tên điểm giao dịch',
  SrcSystem: 'Hệ thống nghiệp vụ',
  AdvBalance: 'Số dư tiền gửi trước hiện tại',
  OrderType: 'Loại nghiệp vụ',
  BlacklistRemark: 'Ghi chú danh sách đen',
  AddedToBlacklist: '{0} đã được thêm vào danh sách đen',
  BalanceInitialized: 'Sau khi khởi tạo số dư, khách hàng "trả trước" không thể chuyển lại thành "ghi nợ"',
  CustomerCodeDuplicate: 'Mã khách hàng trùng lặp',
  NoMatchStateBySelected: 'Không có bản ghi nào được chọn có trạng thái [{0}]',
  SendCustomerInfo: 'Gửi danh sách',
  SendCustomerRemind: '*Lưu ý: Vui lòng xác nhận mã và tên bộ phận quản lý khách hàng khớp với mã và tên cơ quan nhận tiền trong hệ thống nghiệp vụ tài chính. Nếu không khớp, không thể đồng bộ số dư và thông tin nạp tiền.'
}
